import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const CenteredWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  width: 100%;
  max-width: 1080px;
  flex-flow: ${props => props.column ? 'column' : 'row'};
  text-align: ${props => props.centeredText ? 'center' : 'left'};
  z-index: 2;
  flex-wrap: wrap;
  img {
    max-width: 85%;
    &:first-child {
      margin: ${props => props.withImage ? '0 0 50px 0' : '0'};
    }
    &:last-child {
      margin: ${props => props.withImage ? '50px 0 0 0' : '0'};
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    aside {
      &:first-child {
        padding-right: ${props => props.withImage ? '40px' : '0'};
      }
      &:last-child {
        padding-left: ${props => props.withImage ? '40px' : '0'};
      }
    }
    flex-wrap: nowrap;
    img {
      max-width: 540px;
      margin: 0 !important;
    }
  }
`;

export default CenteredWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/CenteredWrapper.js